const KyrgyzstanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111726)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#D80027"
      />
      <path
        d="M29.7813 20.0007L25.7848 21.8805L27.913 25.7514L23.5729 24.921L23.0232 29.305L20.0002 26.0808L16.9774 29.305L16.4274 24.921L12.0878 25.7512L14.2159 21.8804L10.2192 20.0007L14.2159 18.1209L12.0878 14.25L16.4273 15.0804L16.9775 10.6963L20.0002 13.9206L23.0234 10.6963L23.5729 15.0804L27.9131 14.25L25.7849 18.1211L29.7813 20.0007Z"
        fill="#FFDA44"
      />
      <path
        d="M20.0005 26.087C23.3623 26.087 26.0875 23.3618 26.0875 20C26.0875 16.6383 23.3623 13.9131 20.0005 13.9131C16.6388 13.9131 13.9136 16.6383 13.9136 20C13.9136 23.3618 16.6388 26.087 20.0005 26.087Z"
        fill="#D80027"
      />
      <path
        d="M16.9568 20.002C16.8101 20.002 16.6654 20.0095 16.5225 20.0237C16.5277 20.8667 16.8327 21.6384 17.3364 22.2378C17.6052 21.5146 18.0064 20.8552 18.5125 20.2908C18.0292 20.1049 17.5049 20.002 16.9568 20.002Z"
        fill="#FFDA44"
      />
      <path
        d="M18.8306 23.2773C19.1962 23.4079 19.5899 23.4795 20.0005 23.4795C20.4111 23.4795 20.8048 23.4079 21.1704 23.2773C20.9711 22.4951 20.5596 21.7968 20.0005 21.248C19.4413 21.7967 19.0299 22.4951 18.8306 23.2773Z"
        fill="#FFDA44"
      />
      <path
        d="M23.013 18.2631C22.4116 17.2236 21.2884 16.5234 20.0009 16.5234C18.7134 16.5234 17.5902 17.2235 16.9888 18.2631C18.0852 18.2687 19.1133 18.5668 20.0009 19.0816C20.8885 18.5668 21.9164 18.2687 23.013 18.2631Z"
        fill="#FFDA44"
      />
      <path
        d="M21.4878 20.2908C21.9938 20.8551 22.3951 21.5145 22.6638 22.2378C23.1676 21.6384 23.4726 20.8667 23.4778 20.0237C23.3348 20.0094 23.1901 20.002 23.0435 20.002C22.4955 20.0019 21.9712 20.1048 21.4878 20.2908Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111726">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default KyrgyzstanSvg;
